import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Labor, SearchCriteria } from '@raptor-fe/core';
import { ServiceUtils } from '../service-utils/service-utils';
import { LoadingHeaders } from '../web-loading-service/web-loading-headers';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LaborService {
    private readonly http = inject(HttpClient);
    private readonly serviceUtils = inject(ServiceUtils);
    private httpHeadersWithNoLoading = LoadingHeaders.httpHeadersWithNoLoading();

    search(tenantId: string, branchId: string, criteria: SearchCriteria, showLoading = true): Observable<Labor[]> {
        return this.http.post<Labor[]>(this.serviceUtils.getBaseUrl('labor', tenantId, branchId) + `/search`, criteria, {
            headers: showLoading ? undefined : this.httpHeadersWithNoLoading,
        });
    }
}
